const initialState = {
  email: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PUBLISHER_EMAIL':
      return {
        ...state,
        ...action.payload
      }

    default:
      return state
  }
}
